import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Content for the card: title, description, details, badge, etc. */
  discountCardContent: PropTypes.shape({
    discountTitle: PropTypes.string.isRequired,
    discountDescription: PropTypes.string,
    discountDetails: PropTypes.node,
    discountSecondaryTitle: PropTypes.string,
    graphicBadge: PropTypes.element
  }).isRequired,
  /** Specify if Discount Card can or cannot show an Error Message */
  children: PropTypes.element,
  /** Action elements: apply button, applied icon, message, remove link. */
  discountCardActions: PropTypes.shape({
    appliedIconBlock: PropTypes.element,
    applyButton: PropTypes.element,
    discountMessage: PropTypes.string,
    removeLink: PropTypes.element
  }),
  /** Indicates if the discount is expired. */
  isExpired: PropTypes.bool,
  /** Indicates if the discount is invalid (combined with error message from children) */
  isInvalid: PropTypes.bool,
  /** Specify the layout orientation */
  orientation: PropTypes.oneOf([null, 'stacked']),
  /** Specify the theme */
  theme: PropTypes.oneOf([null, 'inverse']),
  /** Specify the variant */
  variant: PropTypes.oneOf([null, 'badged'])
};
function DiscountCard(_ref) {
  var children = _ref.children,
    discountCardActions = _ref.discountCardActions,
    discountCardContent = _ref.discountCardContent,
    isExpired = _ref.isExpired,
    isInvalid = _ref.isInvalid,
    orientation = _ref.orientation,
    theme = _ref.theme,
    variant = _ref.variant;
  var discountDescription = discountCardContent.discountDescription,
    discountDetails = discountCardContent.discountDetails,
    discountSecondaryTitle = discountCardContent.discountSecondaryTitle,
    discountTitle = discountCardContent.discountTitle,
    graphicBadge = discountCardContent.graphicBadge;
  var appliedIconBlock = discountCardActions.appliedIconBlock,
    applyButton = discountCardActions.applyButton,
    discountMessage = discountCardActions.discountMessage,
    removeLink = discountCardActions.removeLink;
  return /*#__PURE__*/React__default.createElement("div", {
    "aria-invalid": isInvalid,
    className: "discount-card",
    "data-expired": isExpired,
    "data-orientation": orientation,
    "data-testid": "discount-card",
    "data-theme": theme,
    "data-variant": variant
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "discount-content",
    "data-testid": "discount-card-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "discount-info",
    "data-testid": "discount-card-info"
  }, graphicBadge, /*#__PURE__*/React__default.createElement("div", {
    className: "discount-info-content",
    "data-testid": "discount-info-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "discount-title",
    "data-testid": "discount-title"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "h4"
  }, discountTitle), /*#__PURE__*/React__default.createElement("div", {
    className: "h4"
  }, discountSecondaryTitle)), discountDescription ? /*#__PURE__*/React__default.createElement("span", {
    className: "discount-description padding-right",
    "data-testid": "discount-description"
  }, discountDescription) : null, discountDetails ? /*#__PURE__*/React__default.createElement("span", {
    className: "discount-details",
    "data-testid": "discount-details"
  }, discountDetails) : null)), /*#__PURE__*/React__default.createElement("div", {
    className: "discount-actions",
    "data-testid": "discount-actions"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "discount-status",
    "data-testid": "discount-status"
  }, applyButton, appliedIconBlock ? /*#__PURE__*/React__default.createElement("div", {
    className: "discount-applied",
    "data-testid": "discount-applied"
  }, appliedIconBlock) : null, removeLink ? /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "discount-removed"
  }, removeLink) : null, discountMessage ? /*#__PURE__*/React__default.createElement("div", {
    className: "discount-message"
  }, discountMessage) : null))), children);
}
DiscountCard.propTypes = propTypes;

export { DiscountCard as default };
//# sourceMappingURL=DiscountCard.js.map
